import { useAudioTime } from "@aircall/tractor";

import { useAutoScrollOnce } from "@/hooks/useAutoScrollOnce/useAutoScrollOnce";
import { TranscriptItem } from "../TranscriptionItem";

import * as S from "./TrascriptionList.styled";

import { useCall } from "@/hooks/useCall/useCall";
import { UtteranceType } from "@/states/call/utterances/utterances.utility.decl";
import { CustomCall } from "@/store/slices/call";

type ContentProps = {
  call: CustomCall;
};

function Content({ call }: ContentProps) {
  const { currentTime } = useAudioTime();

  // Allows us to display the name of the speaker only once, when you have multiple utterances from the same speaker in a row.
  const shouldDisplayName = (utterance: UtteranceType) => {
    const previousUtterance =
      call.utterances?.[call.utterances.indexOf(utterance) - 1];

    return (
      !previousUtterance || previousUtterance.channel !== utterance.channel
    );
  };

  return (
    <>
      {call.utterances?.map((utterance, index) => (
        <TranscriptItem
          key={index}
          displayName={shouldDisplayName(utterance)}
          currentTime={currentTime}
          active
          utterance={utterance}
          index={index}
        />
      ))}
    </>
  );
}

export function TranscriptionList() {
  const { call } = useCall();

  // Auto scroll when we have some matches
  useAutoScrollOnce();

  if (!call?.utterances?.length) {
    return null;
  }

  return (
    <S.Container data-test="utterances-wrapper">
      <Content call={call} />
    </S.Container>
  );
}
